module.exports = __webpack_public_path__ + "static/media/bg3.1ab421d5.jpg";